import {createReducer} from "./index";
import {convertToDate} from "../projections";
import * as R from 'ramda';
import {ADD_BIDS, REMOVE_BID} from "../actions/bids";

/*
Structure of bids model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        parentbidid: string // uuid
        name: string // project name
        number: string // the internal number
        address: string
        address2: string
        city: string
        state: string
        zip: string
        country: string
        createdbyuserid: string // uuid
        owneruserid: string // uuid
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        active: bool
        status: string // code-driven code_bidstatus
        dateopened: datetime
        estimatedcompletiondate: date
        contractsize:
        estimatedcost:
        customername: string
        architectname: string
        engineername: string
        siteownername: string
        csicodes: array of string // code-driven code_csi
        description: string
        subcontractorbidduedate: date
        duetime: time
        proposalsbidto: string
        prebidmeetingdate: date
        prebidmeetingtime: time
        prebidmeetinglocation: string
        prebidmeetingrequired: bool
        industries: array of string // code-driven code_industry
        sectors: array of string // code-driven code_sector
        setasides: array of string // code-driven code_setaside
        newconstruction: bool
        union: bool
        certifiedpayroll: bool
        prevailingwage: bool
        ccipinsurance: bool
        datecreated: datetime
        abbreviation: string
        internalnumber: string
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
  }

}
 */

const bidsInitial = {
  data: {},
  indexes: {},
};

const bidsReducer = createReducer(bidsInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [ADD_BIDS]: (state, action) => {
      let newState = state;
      action.payload.forEach(bid => {
        bid.resource.datecreated = convertToDate(bid.resource.datecreated);
        bid.resource.bidduedatetime = convertToDate(bid.resource.bidduedatetime);
        bid.resource.prebidmeetingdatetime = convertToDate(bid.resource.prebidmeetingdatetime);
        newState = R.over(R.lensPath(['data', bid.resource.id]), () => bid)(newState);
      });
      return newState;
    },
    [REMOVE_BID]: (state, action) => {
      const { bidId } = action.payload;
      return R.dissocPath(['data', bidId], state);
    },
  });

export default bidsReducer;



// WEBPACK FOOTER //
// ./src/reducers/bids.js